import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Typography } from '@/src/elements/text/Typography'

import type { TChatMessageProps } from '../ChatMessage.types'
import { ChatMessageBubble } from '../ChatMessageBubble'
import { ChatMessageTimestamp } from '../ChatMessageTimestamp'

type TChatMessageWarningProps = Pick<TChatMessageProps, 'createdAt' | 'isSender' | 'lastOfBatch'>

export const ChatMessageWarning = ({ createdAt, isSender, lastOfBatch }: TChatMessageWarningProps): ReactNode => (
  <ChatMessageBubble
    isSender={isSender}
    lastOfBatch={lastOfBatch}
    firstOfBatch={false}
    className="bg-default-bg-light p-4 mt-4"
  >
    <Typography bold>
      <FormattedMessage id="message.automatic-message" />
    </Typography>
    <Typography>
      <FormattedMessage id={isSender ? 'message.suspicious.sent' : 'message.suspicious.received'} />
    </Typography>
    {lastOfBatch && <ChatMessageTimestamp color="default" createdAt={createdAt} />}
  </ChatMessageBubble>
)
